import type { AcquisitionItem } from '../stores/acquisitionsStore';

/**
 * Acquisitions economy XP (Ecological — the "Acquisitions" area, on the slot that
 * used to be Time Architecture). A DERIVED view, two earners:
 *  • LISTING a thing to get is worth a little — capturing it offloads the mental
 *    load of holding it in your head.
 *  • ACQUIRING it (marking it done) is worth more — the follow-through / payoff.
 *
 * The SAME value credits the Ecological domain (useUserStats) and the Acquisitions
 * area rank (useDisciplines) — credit-once, no re-mint. Purely derived over the
 * current list, so deleting an item removes its XP (no farming). Pure + idempotent.
 */
export const ACQUISITION_LIST_XP = 10;
export const ACQUISITION_ACQUIRED_XP = 25;

export function computeAcquisitionsXP(items: AcquisitionItem[]): number {
  let xp = 0;
  for (const it of items) {
    xp += ACQUISITION_LIST_XP;
    if (it.acquired) xp += ACQUISITION_ACQUIRED_XP;
  }
  return xp;
}
